<template>
	<div>
		<div class="row">
			<div class="col-md-6">
				<ColourPicker id="colour" :form="values" :errors="errors"/>
			</div>
		</div>
		<div class="row">
			<div class="col-md-12 text-right">
				<button class="button-action" @click="save">Save Changes</button>
			</div>
		</div>
	</div>
</template>

<script>
import ColourPicker from '../Form/ColourPicker.vue'

export default {
	components: {
		ColourPicker
	},
	props: [
		'age',
	],
	data() {
		return {
			values: {},
			errors: {},
			requiredFields: ['colour']
		}
	},
	methods: {
		formIsValid() {
			let validForm = true

			this.errors = {}

			this.requiredFields.forEach(field => {
				if(!this.values.hasOwnProperty(field) || this.values[field] == '') {
					this.errors[field] = 'This field is required.'
					validForm = false
				}
			})

			return validForm
		},
		save() {
			if(!this.formIsValid()) {
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'Form error - please check and re-submit',
					timeout: 3000
				})
				return
			}

			this.$store.commit('app/setLoading', true)
			this.$store.dispatch(`age/update`, this.values)
			.then(() => {
				this.$store.commit('app/setLoading', false);
				this.$store.dispatch('app/addAlert', {
					type: 'success',
					message: `Age has been edited`,
					timeout: 3000
				})
				this.$emit('close');
			})
			.catch(err => {
				this.$store.commit('app/setLoading', false)
				this.$store.dispatch('app/addAlert', {
					type: 'error',
					message: 'An Error occurred, please try later',
					timeout: 3000
				})
			})
		}
	},
	mounted() {
		if(this.age) {
			this.values = JSON.parse(JSON.stringify(this.age))
		}
	}
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Age/Form.vue